import React from 'react'

function WrapperParallax({children}) {
    return (
        <div style={{
            perspective: "1px",
            height: "100vh",
            overflow:"hidden auto",
        }}>
            {children}
        </div>
    )
}

export default WrapperParallax
